module.exports = __webpack_public_path__ + "static/logo-9b23cec1d14d4254ccea8cf13a3665ba.png";